import { render, staticRenderFns } from "./IssuePreviewOffice.vue?vue&type=template&id=3c63a7cd&"
import script from "./IssuePreviewOffice.vue?vue&type=script&lang=js&"
export * from "./IssuePreviewOffice.vue?vue&type=script&lang=js&"
import style0 from "./IssuePreviewOffice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports